import React, {useState} from 'react';
import styled from 'styled-components';
import Button from '../../BaseComponentWrappers/MotifButton';
import {labels} from '../../../../util/utils';
import CreateEditAccountModalWrapper from '../../EntityCrud/CreateEditAccountModalWrapper';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';

export default function CreateEditAccounts(props) {
	const {isCreate, isEdit, onClose, accountId, label, createMinimalAccount} = props;
	const [showAccountsModal, setShowAccountsModal] = useState(false);

	const handleOnClick = () => {
		setShowAccountsModal(true);
	};

	const showHideAccountsModal = () => {
		setShowAccountsModal(!showAccountsModal);
		/*reload the underlying body*/
		onClose && onClose();
	};

	return (
		<>
			<StyledCreateAccounts className="StyledCreateAccounts">
				{/* {label && <Icon src={IconoirPlusCircle} onClick={handleOnClick} />} */}
				<Button
					variant="text-alt"
					className={`manageAccount ${label ? 'withIcon' : ''}`}
					onClick={handleOnClick}
					showLabel
					isEllipsed
					buttonLabel={label ? label : isCreate ? labels.entityCreateAccountLabel : labels.editAccount}
					noOfLines={1}
					showIcon={label}
					iconSource={IconoirPlusCircle}
				/>
			</StyledCreateAccounts>
			{showAccountsModal && (
				<CreateEditAccountModalWrapper
					isCreate={isCreate}
					isEdit={isEdit}
					createMinimalAccount={createMinimalAccount}
					showModal={showAccountsModal}
					setShowModal={showHideAccountsModal}
					accountId={accountId} // for edit, accountId is enough, rest of the account details will be fetched by the modal
				/>
			)}
		</>
	);
}

const StyledCreateAccounts = styled.section`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	width: auto;
	max-width: var(--px-220);
	height: 100%;
	.motif-icon {
		display: flex;
		align-items: center;
		cursor: pointer;
		width: var(--px-20);
		svg {
			width: var(--px-20) !important;
			height: var(--px-20) !important;
			fill: none !important;
		}
	}
`;
